<template>
    <div class="container-fluid">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{$ml.get('IMPORT_EXCEL')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body crm-modal-body">
            <div class="row">

                <div class="col-12 filter mb-2">
                    <div class="row" id="stepOne" v-show="!uploadStatus">
                        <div class="col-xs-12 col-sm-12 col-md-12 border-line-80 border-radius-20 pb-3 overflow-hidden">
                            <div class="row p-3 bg-light border-radius-top-left-right-20 mb-4"><b>{{$ml.get('UPLOAD_EXCEL_FILE_IMPORT')}}</b></div>
                            <div class="row">
                                <div class="col-6">
                                    <img src="../assets/excel-import.png" class="img-fluid">
                                    <div class="w-100 d-flex justify-content-center align-items-center mt-3">
                                        <i class="mr-2">
                                            <img src="../assets/xls-icon.png">
                                        </i>
                                        {{$ml.get('SAMPLE_EXCEL_FILE')}}
                                    </div>
                                </div>
                                <div class="col-6">
                                    <img src="../assets/eslestirme.png" class="img-fluid">
                                    <div class="w-100 d-flex justify-content-center align-items-center mt-3">
                                        <i class="mr-2">
                                            <img src="../assets/info-icon.png">
                                        </i>
                                        {{$ml.get('MATCH_HEADERS_TO_TRANSFER')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-4 text-center">
                            <div>
                                <input type="checkbox" id="checkbox" v-model="hasHeaderRow">
                                <label for="checkbox">{{$ml.get('MY_FILE_HAS_HEADERS')}}</label>
                            </div>
                        </div>
                        <div class="col-12 mt-2 justify-content-center d-flex">
                            <button type="submit" class="btn btn-click mb-2 border-radius-20 mcBgDark text-white px-5 mx-2" @click="fileUpload">{{$ml.get('SEND')}}</button>
                            <div class="file-upload mx-2">
                                <label for="file" class="file-upload__label px-5 py-2">{{$ml.get('SELECT_FILE')}}</label>
                                <input class="file-upload__input" type="file" name="file-upload" id="file" ref="file">
                            </div>
                        </div>
                        <span class="col-12 text-center">{{$ml.get('MAX_ROWS_IMPORT')}}</span>
                    </div>
                    <div class="row" id="stepTwo" v-show="uploadStatus">
                        
                        <div class="col-xs-12 col-sm-12 col-md-12 border-line-80 border-radius-20 pb-3" id="pairingArea">
                            <div class="row justify-content-between p-3 bg-light border-radius-top-left-right-20 mb-4"><b class="float-left">{{$ml.get('MATCH_COLUMN_HEADERS_IN_THE_FILE')}}</b> <b class="float-right">{{fileName}}</b></div>
                            
                            <div class="row">
                                <div class="col-6" v-for="count in 2">
                                    <template v-for="col in columnsSlice(count)" :key="col.prop"><div v-if="col && (col.prop!='_id' || operationTypeId !='0') && col.prop!='x'" class="row align-items-center mb-3">
                                        <label for="ad" class="m-0 col-4" v-if="col['prop']=='prices'">{{$ml.get('PRICE')}} TL</label>
                                        <label for="ad" class="m-0 col-4" v-else>{{col['name']}}</label>
                                        <div class="col-8 d-flex" :class="{valid:col['valid']}">
                                            <select class="new-select form-control border-radius-20 f-14 light-blue-border h-32" @change="changeSelect($event,col['prop'])" >
                                                <option value="none"></option>
                                                <option :value="index" v-for="(colon,index) in columnHeader" :disabled="headerControl.includes(index)">{{colon}}</option>
                                            </select>
                                        </div>
                                    </div></template>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 border-line-80 border-radius-20 pb-3 mt-3 overflow-hidden" v-if="uploadStatus">
                            <div class="row p-3 bg-light border-radius-top-left-right-20 mb-4"><b>{{$ml.get('FILE_TO_UPLOAD')}}</b></div>
                            <div id="grid-template">
                                <div class="table-body-wrapper">
                                    <table class="table-body gridTable">
                                        <thead class="gridHead">
                                            <th v-for="title in columnHeader">
                                                {{title}}
                                            </th>
                                        </thead>
                                        <tbody>
                                            <template v-for="(entry,index) in fileContent" :key="index">
                                                <tr :class="{trBgColor:trColor(index)}" v-if="hasHeaderRow && index!=0">
                                                    <td v-for="content in fileContent[index]">{{content}}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div v-if="deleteUpdate === false" class="col-xs-12 col-sm-12 col-md-12 border-line-80 border-radius-20 pb-3 mt-3 overflow-hidden d-none">
                        </div>
                        <div v-else class="col-xs-12 col-sm-12 col-md-12 border-line-80 border-radius-20 pb-3 mt-3 overflow-hidden">
                            <div class="row p-3 bg-light border-radius-top-left-right-20 mb-4"><b>{{$ml.get('HOW_WOULD_YOU_LIKE_TO_PROCED_WIDTH_THE_RECORDS_ON_THE_FILE')}}</b></div>
                            <div class="form-control">
                                <label class="mr-2">
                                    <input type="radio" id="0" value="0" v-model="operationTypeId" name="operationTypeId">
                                    {{$ml.get('ADD_AS_NEW_RECORD')}}
                                </label>
                                <label class="mr-2">
                                    <input type="radio" id="1" value="1" v-model="operationTypeId" name="operationTypeId">
                                    {{$ml.get('UPDATE_EXISTING_RECORD')}}
                                </label>
                                <label class="mr-2">
                                    <input type="radio" id="2" value="2" v-model="operationTypeId" name="operationTypeId">
                                    {{$ml.get('BOTH')}}
                                </label>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
          </div>
          <div class="modal-footer" v-if="uploadStatus">
              <button type="button" class="btn btn-default" @click="returnUpload">{{$ml.get('RETURN_TO_UPLOAD')}}</button>
              <button type="button" class="btn btn-primary" @click="importEnd">
                {{$ml.get('IMPORT')}}
              </button>
          </div>
    </div>    
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapState,mapActions } from 'vuex'
import swal from 'sweetalert'
export default {
    props:{
        columns:{ type:Array, default:() => [] },
        page:{ type:String, default:'' },
        deleteUpdate:{ type:Boolean, default:false }
    },
    name:'import',
    data (){
        return {
            isTab1:true,
            isTab2:false,
            uploadStatus:false,
            file:'',
            fileName:'',
            columnMap:{},
            fileContent:[],
            columnHeader:{},
            docId:'',
            hasHeaderRow:true,
            headerControl:[],
            validProp:[],
            operationTypeId:0
        }
    },
    methods:{
        importEnd(){

            // console.log('deleteUpdate')
            // console.log(this.deleteUpdate)

            let validCount=this.validProp.length
            for(var col in this.columnMap){
                if(col=="prices.tl"){
                    col="prices"
                }

                if(this.validProp.includes(col)){
                    validCount--
                }
            }

            if(validCount!=0){
                swal({
                        title: this.$ml.get("REQUIRED_FIELDS_ARE_AVAILABLE"),
                        text: this.$ml.get("PLEASE_FILL_IN_THE_FIELDS"),
                        icon: "error",
                        dangerMode: true,
                    })
            }else{
                 
                
                let url = ""
                if(this.page=="product"){
                    url="/importProducts"
                }else if(this.page=="contact"){
                    url="importContacts"
                }else if(this.page=="organization"){
                    url="importOrganizations"
                }else if(this.page=="opportunities"){
                    url="importDeals"
                }

                console.log('url')
                console.log(url)


                axios({
                    method: "POST",
                    url: url,
                    baseURL: this.baseUrl,
                    data: {
                        columnMap:this.columnMap,
                        docId: this.docId,
                        hasHeaderRow:this.hasHeaderRow,
                        operationTypeId:parseInt(this.operationTypeId)
                    },
                    withCredentials: true
                })
                .then(res => {
                    if(res.data.status.code==0){    
                        swal({
                            title: this.$ml.get("SUCCESSFUL"),
                            text: this.fileName + " isimli dosyadan gelen "+ res.data.content.successfulUpdateCount+" "+this.page+" güncellendi. "+res.data.content.successfulInsertCount+" "+this.page+" eklendi.",
                            icon: "success",
                            dangerMode: true,
                        }).then((willDelete) => {
                            if (willDelete) {
                               this.closeTakeModal()
                               this.$emit('closeTakeModal');
                            }
                        })
                         
                    }else{
                        if(res.data.status.code==97){
                            var sblitText = res.data.status.details.split(':')
                            var sblitTextLast = sblitText[1].split('for')
                            if(this.$ml.current=="tr"){
                                var text = "Geçersiz Veri: "+sblitTextLast[0]+" verisi "+sblitTextLast[1]+" sütununa gelemez."
                            }else{
                                var text = "Invalid Data: "+sblitTextLast[0]+" entry for "+sblitTextLast[1]+" column is not valid."
                            }
                        }else{
                            var text = res.data.status.details
                        }
                        swal({
                            title: res.data.status.desc,
                            text: text,
                            icon: "error",
                            dangerMode: true,
                        })
                         
                        return false
                    }
                })
            }
        },

        changeSelect(event,prop){
            if(prop=="prices"){
                prop="prices.tl"
            }

            this.headerControl=[]

            if(event.target.value=="none"){
                this.$delete(this.columnMap, prop)
            }else{
                this.columnMap[prop] = parseInt(event.target.value)
            }

            for(var col in this.columnMap){
                this.headerControl.push(this.columnMap[col])
            }

            console.log(this.columnMap)

            
        },

        //take a single JavaScript File object
        getFile(file) {
            var reader = new FileReader();
            return new Promise((resolve, reject) => {
                reader.onerror = () => { reader.abort(); reject(new Error("Error parsing file"));}
                reader.onload = function () {

                    //This will result in an array that will be recognized by C#.NET WebApi as a byte[]
                    let bytes = Array.from(new Uint8Array(this.result));

                    //if you want the base64encoded file you would use the below line:
                    let base64StringFile = btoa(bytes.map((item) => String.fromCharCode(item)).join(""));

                    //Resolve the promise with your custom file structure
                    resolve({ 
                        bytes: bytes,
                        base64StringFile: base64StringFile,
                        fileName: file.name, 
                        fileType: file.type
                    });
                }
                reader.readAsArrayBuffer(file);
            });
        },

        //using the functions with your file:

        
        trColor(index){
            if(index%2===0){
                return true
            }else{
                return false
            }
        },

        fileUpload(){
            this.file=this.$refs.file.files[0]
            if(this.file!=undefined && this.file!=null){
                this.getFile(this.file).then((customJsonFile) => {
                     
                    var content=customJsonFile['base64StringFile'];

                    this.fileName=customJsonFile['fileName']
                    var fileEx=this.fileName.split('.').slice(-1)[0]

                    if(fileEx=="xlsx" || fileEx=="xls"){
                        axios({
                            method: "POST",
                            url: "/saveUserDocument",
                            baseURL: this.baseUrl,
                            data: {
                                fileContent: content,
                                fileName:this.fileName,
                                hasHeaderRow:this.hasHeaderRow
                            },
                            withCredentials: true
                        }).then(res => {
                            if(res.data.status.code==0){
                            this.fileContent = res.data.content.preview.firstElevenRows
                            this.columnHeader = res.data.content.preview.firstElevenRows[0]
                            this.docId = res.data.content.docId
                            this.uploadStatus=true

                             
                            }else{
                                swal(res.data.status.desc)
                                 
                                return false
                            }
                             
                        }).catch(error => {
                            swal(this.$ml.get('ERROR'))
                             
                        })
                    }else{
                        swal(this.$ml.get('FILE_FORMATS'))
                     
                    }
                })
            }else{
                swal({
                        title: this.$ml.get('NO_FILE_SELECTED'),
                        text: this.$ml.get('PLEASE_SELECT_AND_UPLOAD_FILES'),
                        icon: "error",
                        dangerMode: true,
                    })
                }
        },
        returnUpload(){
            this.uploadStatus=false
        },
        closeTakeModal(){
            this.$delete(this.columns[0],'valid')
            this.uploadStatus=false,
            this.fileName='',
            this.columnMap={},
            this.fileContent=[],
            this.columnHeader={},
            this.docId="",
            this.hasHeaderRow=true,
            this.headerControl=[],
            this.operationTypeId=0
            $("#importFile").modal("hide")
        },

        columnsSlice(count) {
            const columnSliceArray=[]

            for(var col in this.columns){
                const column = this.columns[col]
                if(column && column.prop!="createdAt" && column.prop!="deals" && column.prop!="status" && column.prop!="addDate" && column.prop!="closedDate"){
                    columnSliceArray.push(column)
                }
            }
            if(count==1){
                return columnSliceArray.slice(0,columnSliceArray.length-Math.floor(columnSliceArray.length/2))
            }else{
                return columnSliceArray.slice(columnSliceArray.length-Math.floor(columnSliceArray.length/2),columnSliceArray.length)
            }
        },
        createValidArray(){
            this.validProp=[]
            for(var col in this.columns){
                const column = this.columns[col]
                if(column && column.valid!=undefined && !this.validProp.includes(column.prop)){
                    this.validProp.push(column.prop)
                }
            }
        },
        ...mapActions([
            'updateLoading'
        ])
    },
    computed:{
        ...mapState([
            'baseUrl',
        ]),
    },
    created(){
        this.createValidArray()
    },
    mounted(){        
        $("#importFile").on("hidden.bs.modal", this.closeTakeModal)

       
    },
    watch:{  
        operationTypeId(){
            if(this.operationTypeId=='1'){
                this.columns[0]['valid']=true
            }else{
                this.$delete(this.columns[0],'valid')
            }
            this.createValidArray()
        }
    }
}
</script>

<style scoped>
.file-upload {
	position: relative;
}
.file-upload__label {
  display: block;
  color: #fff;
  border-radius: 20px!important;
  background: #222;
  border-radius: .4em;
  transition: background .3s;
  background-color: #3767a0!important;
  padding: .375rem .75rem;
  cursor: pointer;
  line-height: 1.5;
}
.file-upload__label:hover{
    background: #344150 !important;
}
.file-upload__input {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    font-size: 1;
    width: 100%;
    height: 100%;
    opacity: 0;
}
.valid:after{
    content: "*";
    color: red;
    left: 0;
    position: absolute;
    top: 0;
    font-size: 20px;
}
.overflow-hidden{
    overflow: hidden;
}
.settingsMenu.active label>i.light-blue-icon-color:before {
    color: #fff!important;
}
.settingsMenu.active label{
    background-color: #3767a0!important;
    border-color: #fff!important;
    color: #fff!important;
}
.settingsMenu label>i.light-blue-icon-color:before {
    margin-top: 2px;
}

.trBgColor{
        background-color:ghostwhite!important;
    }

#grid-template > .table-body-wrapper {
    width: 100%;
}

#grid-template {
    width: 100%;
    overflow-x: scroll;
    overflow-y: scroll;
    max-height: 50vh;
}

.gridTable {
    border-collapse: separate!important;
    -moz-border-radius: 10px;
    -webkit-border-radius: 10px;
    border-spacing: 0;
    width: 100%;
}

.gridTable thead th {
    border-right: 0.5px solid white;
    border-top: 0.5px solid white;
    border-bottom: 0.5px solid white;
    border-left-color: white;
    background-color: #3767a0;
    color:white;
    margin-right: 3px;
    font-family: "font-family-bold";
    font-size: 14px;
    padding-left: 6px;
}

.gridTable tbody tr td {
    height: 34px;
    border-right: 0.5px solid #3767a0;
    border-bottom: 0.5px solid #3767a0;
    font-family: "font-family-regular";
    font-size: 14px;
    padding-left: 6px;
}

.gridTable tbody tr td:hover .editIcon{
    /*display: inline-block;*/
}

.gridTable tbody tr:hover {
    background-color: #66D1FF30!important;
    /* HOVER */
}

.gridTable tbody tr td:hover {
    background-color: white;
    border: 1px solid #66D1FF;
}


#grid-template > .table-body-wrapper {
    flex: 1;
}
body{
    font-family: Helvetica Neue, Arial, sans-serif;
    font-size: 14px;
    color: #555;
}

table {
    border-spacing: 0;
    width: 100%;
}

th {
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-weight: bold;
}

td {
    border-bottom: 1px #66D0FF solid;
}
th.checkboxCol{
    border: white!important;
    border-right: 0.5px solid white!important;
    border-top: 0.5px solid white!important;
    border-bottom: 0.5px solid white!important;
}
th.checkboxCol,td.checkboxCol{
    width: 30px!important;
    min-width: 30px!important;
}

th {
    min-width: 75px;
/* padding: 10px 20px; */
}

th.active {
    font-weight: bolder;
}

th:last-child{
    /*float:right;*/
}

th.active .arrow {
    opacity: 1;
}

th.active .arrow.asc{
    border-bottom: 4px solid #2396ca;
}

th.active .arrow.dsc{
    border-top: 4px solid #2396ca;
}

#pairingArea{
    max-height: 50vh;
    overflow-y: scroll;
}

</style>
